import React from 'react';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import HeroSection from '../components/sections/HeroSection';
import AboutSection from '../components/sections/AboutSection';
import ServicesSection from '../components/sections/ServicesSection';
import StatsSection from '../components/sections/StatsSection';
import TeamSection from '../components/sections/TeamSection';
import PortfolioSection from '../components/sections/PortfolioSection';
import ObjectivesSection from '../components/sections/ObjectivesSection';
import ContactSection from '../components/sections/ContactSection';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-[#0a0a0c]">
      <Header />
      <main>
        <HeroSection />
        <AboutSection />
        <ServicesSection />
        <StatsSection />
        <TeamSection />
        <PortfolioSection />
        <ObjectivesSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
